var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 49,
    viewBox: "0 0 51 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.5089 48.8138C10.2786 49.4606 8.88243 48.3271 9.13106 46.88L11.7767 31.4292L0.547144 20.4666C-0.501541 19.4409 0.0435201 17.5659 1.4492 17.3634L17.0615 15.0899L24.023 0.955468C24.651 -0.318489 26.3499 -0.318489 26.9778 0.955468L33.9393 15.0899L49.5516 17.3634C50.9573 17.5659 51.5024 19.4409 50.4505 20.4666L39.2242 31.4292L41.8698 46.88C42.1184 48.3271 40.7223 49.4606 39.4919 48.8138L25.4956 41.4445L11.5089 48.8138Z",
    fill: "#8FAB68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.667ed0759b6b8bf10d8d17f7e8ed8b16.svg";
export { ForwardRef as ReactComponent };